import { useCallback } from "react";
import { useDoctorContext } from "@contexts";
import {
  BANK_TRANSFER_ATTEMPTS_LIMIT,
  BANK_TRANSFER_ATTEMPTS_TTL_MS,
} from "@constants/index";
import { usePersistentCounter } from "./usePersistentCounter";

export const useBankTransferAttempts = () => {
  const { code } = useDoctorContext();

  const [attempts, setAttempts, resetAttempts] = usePersistentCounter(
    `bankTransferAttempts:${code}`,
    0,
    BANK_TRANSFER_ATTEMPTS_TTL_MS,
  );

  const registerAttempt = useCallback(
    () => setAttempts((previous) => previous + 1),
    [setAttempts],
  );

  return {
    attempts,
    registerAttempt,
    resetAttempts,
    hasExhaustedAttempts: attempts >= BANK_TRANSFER_ATTEMPTS_LIMIT,
  };
};
